export default __webpack_public_path__ + "static/media/Wavey-Fingerprint.b3f83e47.svg";